import axios from "axios";
import config from "../config";

export function getTasks() {
  return axios.get(`${config.api_url}/tasks`);
}
